import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const { content } = useContent();
  const brand = content.brand || {};
  return (
    <footer className="bg-[#1C1917] text-white/70 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-[#C5A059]" />
          <span className="font-serif text-lg text-white">{brand.name || "Ascarya Dekorasi"}</span>
        </div>
        <p className="text-xs tracking-wide text-white/50 text-center">
          © {new Date().getFullYear()} Ascarya Dekorasi. Wujudkan momen istimewa
          dengan dekorasi yang berkesan.
        </p>
        <Link
          to="/admin/login"
          data-testid="footer-admin-link"
          className="text-[10px] tracking-widest uppercase text-white/40 hover:text-[#C5A059] transition-colors"
        >
          Admin
        </Link>
      </div>
    </footer>
  );
};
